import { Navigate } from "react-router-dom";
import { usePermission } from "./PermissionProvider";

const ProtectedRoute = ({ pageKey, children }) => {
  const { permissions, loading } = usePermission();
  if (loading) return null;
  const key = pageKey.toLowerCase();
  if (!permissions.pages.includes(key)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
